import { useMemo } from "react";
import { useTabs } from "@/store/tabs";
import { useAllSpaceItems } from "@/data/store";
import { NoteView } from "@/views/NoteView";
import { FolderView } from "@/views/FolderView";
import { TabBar } from "./TabBar";
import { EditorToolbar } from "./EditorToolbar";
import { LogoMark } from "@/ui/Logo";
import { Kbd } from "@/ui/Kbd";
import s from "./CenterArea.module.css";

export function CenterArea() {
  const { groups, activeGroupId, setActiveGroup } = useTabs();
  const spaces = useAllSpaceItems();
  const items = useMemo(() => spaces.flatMap((sp) => sp.items), [spaces]);

  return (
    <div className={s.column}>
      <div className={s.split}>
        {groups.map((group, gi) => {
        const activeTab = group.tabs.find((t) => t.id === group.activeTabId);
        const item = activeTab ? items.find((i) => i.id === activeTab.itemId) : undefined;
        return (
          <div
            key={group.id}
            className={[s.center, group.id === activeGroupId && groups.length > 1 ? s.centerActive : ""].join(" ")}
            onFocusCapture={() => setActiveGroup(group.id)}
            onMouseDownCapture={() => setActiveGroup(group.id)}
          >
            <TabBar group={group} isLastGroup={gi === groups.length - 1} />
            <div className={s.content}>
              {!activeTab || !item ? (
                <Welcome />
              ) : item.type === "folder" ? (
                <FolderView key={item.id} folderId={item.id} />
              ) : item.type === "note" ? (
                <NoteView key={item.id} noteId={item.id} />
              ) : (
                <Welcome />
              )}
            </div>
            {item?.type === "note" ? <EditorToolbar noteId={item.id} /> : null}
          </div>
        );
        })}
      </div>
    </div>
  );
}

function Welcome() {
  return (
    <div className={s.welcome}>
      <div className={s.welcomeInner}>
        <LogoMark size={48} />
        <div className={s.shortcuts}>
          <span className={s.shortcutLabel}>Open or create a note</span>
          <Kbd combo="Mod+P" />
          <span className={s.shortcutLabel}>New note</span>
          <Kbd combo="Mod+N" />
          <span className={s.shortcutLabel}>All commands</span>
          <Kbd combo="Mod+Shift+P" />
        </div>
      </div>
    </div>
  );
}
